var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M8.73.75a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm3.906 5.713a1.677 1.677 0 0 1-.364.754c-.054.063-.107.125-.165.181-1.485 1.47-2.97 2.939-4.456 4.407a.43.43 0 0 1-.163.1c-.758.245-1.517.488-2.277.73-.189.06-.348-.014-.383-.188a.41.41 0 0 1 .017-.19c.217-.731.44-1.461.654-2.194a.864.864 0 0 1 .23-.387C7.097 8.314 8.46 6.95 9.822 5.584c.34-.341.684-.646 1.18-.74h.307c.006.031.01.01.016.012.48.078.809.372 1.081.75.121.17.2.365.231.57v.287z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleEdit);
export default __webpack_public_path__ + "static/media/circle-edit.71387186d27502580946b7c782858f5f.svg";
export { ForwardRef as ReactComponent };